import serveCSV from './serveCSV';
import parseHtmlToString from './parseHtmlToString';

const toCapitalized = (str) => {
    return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
};

const toCapitalizedRole = (str) => {
    return str
        .split('_')
        .map((v) => (v === 'RCKMS' ? v : toCapitalized(v)))
        .join(' ');
};

const BuildAdminReport = (specMap = null, reportType = null) => {
    if (typeof specMap != 'object' || specMap == null || typeof reportType != 'string') {
        console.log(err);
        alert('Admin Report Generation Failed');
    }

    let reportLines = [],
        report;

    if (reportType === 'all-value-sets-concepts') {
        let vs;
        for (let spec of Object.keys(specMap)) {
            for (let concept of specMap[spec]) {
                for (let rel of concept.conceptRels) {
                    vs = rel.valueSetDTO;
                    reportLines.push([spec, vs.name, vs.oid, vs.versionStatus, vs.version, concept.code]);
                }
            }
        }
        report = [
            [
                'Reporting Specification',
                'Value Set Name',
                'Value Set',
                'Value Set Status',
                'Value Set Version',
                'Concept Name'
            ],
            ...reportLines
        ];
        serveCSV(report, 'RCKMS_All_Value_Set_Concept_Export');
    } else if (reportType === 'all-condition-criteria') {
        /**
         * RCKMSDEV-221
         * Breakout previous data into additional fields
         */

        const tbxUnits = {
            'DAYS': 'Day',
            'WEEKS': 'Week',
            'MONTHS': 'Month',
            'YEARS': 'Year'
        };

        for (const [, datum] of Object.entries(specMap)) {
            const [conditions, reportingSpecification] = datum;
            const conditionName = reportingSpecification?.name ?? '';
            const conditionVersion = reportingSpecification?.version ?? '';
            const { status } = reportingSpecification;

            conditions.map((criteria) => {
                const { criteriaDTO, label, relId, ruleSetHtml, timeboxEnabled, timeboxDuration, timeboxDurationUnit } = criteria;
                const { criteriaId, criteriaType, name, timeboxEligible, implemented } = criteriaDTO;

                let finalLabel = label;
                if (timeboxEligible && timeboxEnabled) {
                    if (typeof timeboxDuration == 'number' && Object.keys(tbxUnits).includes(timeboxDurationUnit)) {
                        finalLabel = `${label} [Timeboxed to ${timeboxDuration} ${tbxUnits[timeboxDurationUnit]}${timeboxDuration != 1 ? 's' : ''}]`;
                    } else {
                        console.warn('Timebox set, however misconfigured for criteriaId: ', criteriaId);
                    }
                }

                reportLines.push([
                    conditionName,
                    conditionVersion,
                    typeof status === 'string'
                        ? status
                            .toLowerCase()
                            .replace(/_/g, ' ')
                            .split(' ', 10)
                            .map((segment) => segment.charAt(0).toUpperCase() + segment.substring(1))
                            .join(' ')
                        : `(undefined)`,
                    finalLabel,
                    relId,
                    toCapitalized(criteriaType),
                    implemented ? 'Yes' : 'No',
                    parseHtmlToString(ruleSetHtml),
                    criteriaId,
                    name
                ]);
            });
        }

        report = [
            [
                'Condition Name',
                'Condition Version',
                'Status',
                'Criteria Name',
                'Criteria ID',
                'Criteria Type',
                'Implemented',
                'Logic',
                'Template ID',
                'Template Name'
            ],
            ...reportLines
        ];
        serveCSV(report, 'RCKMS_All_Conditions_Criteria_Export', '|');
    } else if (reportType === 'all-user-accounts') {
        let userDTO;
        specMap = specMap.sort((a, b) => {
            // Set toLowerCase for case-insensitive sorting, or empty if unset.
            let jna = a?.jurisdictionName?.toLowerCase() || '';
            let jnb = b?.jurisdictionName?.toLowerCase() || '';
            return jna < jnb ? -1 : jna > jnb ? 1 : 0;
        });
        for (let user of specMap) {
            userDTO = user.userDTO;
            /*
                Username: userDTO.username
                User First Name: userDTO.firstName
                User Last Name: userDTO.lastName
                User Email: userDTO.email
                User Role: role
                User Jurisdiction: jurisdictionName
             */
            reportLines.push([
                user.userDTO.username,
                user.userDTO.firstName,
                user.userDTO.lastName,
                user.userDTO.email,
                toCapitalizedRole(user.role),
                typeof user.jurisdictionName == 'string' ? user.jurisdictionName : 'N/A',
                user.notes
            ]);
        }

        report = [
            ['Username', 'User First Name', 'User Last Name', 'User Email', 'User Role', 'User Jurisdiction', 'Notes'],
            ...reportLines
        ];

        serveCSV(report, 'RCKMS_User_Accounts');
    } else {
        console.log('Invalid Report Type');
        alert('Admin Report Generation Failed');
    }
};

export default BuildAdminReport;
